import { useTranslation } from 'next-i18next';
import React from 'react';
import { useObjectId } from '@hotelplan/libs.context.object-id';
import PdpDestinationAttributes from 'components/domain/pdp/PdpDestinationAttributes';
import {
  PdpGeoPageImage,
  PdpGeoPageSubTitle,
  PdpGeoPageText,
  PdpGeoPageTitle,
} from 'components/domain/pdp/PdpGeoCommon';
import PdpPageContainer from 'components/domain/pdp/PdpPageContainer';
import { useGetPdpDestinationQuery } from 'graphql/pdp/GetPdpDestination.generated';
import PdpRegionSkeleton from './PdpRegionSkeleton.skeleton';

const PdpRegion: React.FC = () => {
  const [t] = useTranslation();
  const { id } = useObjectId();
  const { loading, data } = useGetPdpDestinationQuery({ variables: { id } });

  if (loading) {
    return (
      <PdpPageContainer>
        <PdpRegionSkeleton />
      </PdpPageContainer>
    );
  }

  const { destinationInfo } = data?.pdp.content;
  const destinationRatings = destinationInfo.destinationAttributes.find(
    item => item.id === 'destination_nature_ratings'
  )?.details;

  return (
    <PdpPageContainer>
      <PdpGeoPageTitle>{destinationInfo.destinationName}</PdpGeoPageTitle>
      <PdpGeoPageText
        dangerouslySetInnerHTML={{
          __html: destinationInfo.destinationLeadText,
        }}
      />
      <PdpGeoPageImage {...destinationInfo.destinationImage} />
      {destinationInfo.destinationFacts && (
        <PdpGeoPageText>{destinationInfo.destinationFacts}</PdpGeoPageText>
      )}
      {destinationRatings && (
        <>
          <PdpGeoPageSubTitle>{t('pdp:region.facts.title')}</PdpGeoPageSubTitle>
          <PdpDestinationAttributes attributes={destinationRatings} />
        </>
      )}
    </PdpPageContainer>
  );
};

export default PdpRegion;
